export const themes = {
  default: {
    thBody:
      'arrow-up arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-light-gray mt-4 p-4 shadow-lg',
  },
  hollow: {
    thBody:
      'arrow-up arrow-large arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-gray-light mt-5 rounded-small shadow-lg',
  },
  solid: {
    thBody: 'bg-white',
  },
};
